import React, { useEffect } from "react";
import "./style.css";
import HeroFooter from "../components/footer";

function Testi() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://static.elfsight.com/platform/platform.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <div>
            <div className="testi">
                <div className="testinside">
                    <div className="elfsight-app-ea2d046d-fb2e-4f1a-ae16-12301ec083bf" data-elfsight-app-lazy></div>
                </div>
            </div>
            <HeroFooter />
        </div>
    );
}

export default Testi;
